import { AlertState } from '@eppendorf/vnls-device-service-utils';
import { HasClassName, Tooltip, TooltipProps } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';

import { AlertStatus } from '$features/monitoring/alert-status/alert-status';

function isAlert(maybeAlert: AlertState | null | undefined): maybeAlert is AlertState {
  if (!maybeAlert || !Object.keys(AlertState).includes(maybeAlert)) {
    return false;
  }

  return maybeAlert === AlertState.Alert || maybeAlert === AlertState.Warn;
}

export interface UnitAlertStateV2Props extends HasClassName {
  alertState?: AlertState | null;
  side: TooltipProps['side'];
}

export function UnitAlertStateV2({
  alertState,
  className,
  side,
}: UnitAlertStateV2Props): ReactElement {
  if (isAlert(alertState)) {
    return <AlertStatus className={className} alertStatus={alertState} />;
  }

  return (
    <Tooltip
      trigger={
        <div role="status" aria-label="no-alerts" className="circle circle--green" />
      }
      side={side}
    >
      OK
    </Tooltip>
  );
}
